import React from "react";
import { VariantBase } from "scmp-sdk/components/newsletter/newsletter-widget/variants/component";

import { Container, theme } from "./styles";

export { config as acquisitionNewsletterPopupThemeConfig } from "./config";
export * from "./hooks";
export const AcquisitionNewsletterPopupTheme: React.FunctionComponent<{
  children?: React.ReactNode;
}> = ({ children, ...props }) => (
  <VariantBase theme={theme}>
    <Container {...props}>{children}</Container>
  </VariantBase>
);

AcquisitionNewsletterPopupTheme.displayName = "AcquisitionNewsletterPopupTheme";
